import { useItem } from './hooks/use-context';

export function Analysis() {
  const { sections } = useItem();

  // Question IDs based on the actual data structure from memory
  const questionIds = {
    analysisText: '3b8d9ae8-7964-443b-be22-ba8946804b17', // Analysis text question
    conclusion: 'b800cb61-dd13-452a-aa6a-144cee783757', // Conclusion radio question
    atoInseguro: '22767639-dba9-424a-b731-d71de9ac0a2f',
    condicaoInsegura: 'aabb31a0-1edf-49a1-af1a-01e475985b20',
    fatorPessoal: 'ac619d3e-a0eb-4da6-a1aa-d230b313fa38',
  };

  // Get the analysis text
  const getAnalysisText = (): string => {
    const question = sections
      .flatMap((section) => section.questions)
      .find((q) => q.question_id === questionIds.analysisText);

    return question?.answers?.[0]?.content || '';
  };

  // Get the selected conclusion option
  const getSelectedConclusion = (): string => {
    const question = sections
      .flatMap((section) => section.questions)
      .find((q) => q.question_id === questionIds.conclusion);

    return question?.answers?.[0]?.content || '';
  };

  // Helper function to check if a specific conclusion option is selected
  const isConclusionSelected = (optionId: string): boolean => {
    const selectedOption = getSelectedConclusion();
    return selectedOption === optionId;
  };

  // Get selected options for checkbox_combo questions
  const getSelectedOptions = (questionId: string): string[] => {
    const question = sections
      .flatMap((section) => section.questions)
      .find((q) => q.question_id === questionId);

    if (!question?.answers) return [];

    return question.answers
      .map((answer) => answer.option || '')
      .filter(Boolean);
  };

  // Get formatted options string separated by "-"
  const getFormattedOptions = (questionId: string): string => {
    const options = getSelectedOptions(questionId);
    return options.length > 0 ? ` / ${options.join(' / ')}` : '';
  };

  return (
    <div
      style={{
        marginBottom: '20px',
        minHeight: '120px',
        width: '100%',
        backgroundColor: '#E0F4E9',
        padding: '10px',
        borderRadius: '6px',
        breakInside: 'avoid',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          width: '100%',
          minHeight: '100px',
          borderRadius: '6px',
          padding: '6px 10px',
          backgroundColor: '#FFFFFF',
        }}
      >
        {/* Analysis Text Section */}
        <div style={{ marginBottom: '1rem' }}>
          <strong>Análise da ocorrência:</strong>
          <div
            style={{
              marginTop: '0.5rem',
              padding: '0.5rem',
              backgroundColor: '#f9f9f9',
              borderRadius: '4px',
            }}
          >
            {getAnalysisText()}
          </div>
        </div>

        {/* Conclusion Section */}
        <div style={{ marginBottom: '1rem' }}>
          <strong>2.1 Conclusão:</strong>
        </div>
        <div
          style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '1px solid #000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                marginRight: '0.5rem',
                color: '#000',
                padding: '6px',
              }}
            >
              {isConclusionSelected('3d5023a7-becb-4124-8621-252863909aa0')
                ? ' x '
                : ''}
            </div>
            <span>
              Ato Inseguro{getFormattedOptions(questionIds.atoInseguro)}
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '1px solid #000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                marginRight: '0.5rem',
                color: '#000',
                padding: '6px',
              }}
            >
              {isConclusionSelected('65ed99da-d964-4c6d-bd39-60553fd3970e')
                ? ' x '
                : ''}
            </div>
            <span>
              Condição Insegura
              {getFormattedOptions(questionIds.condicaoInsegura)}
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '1px solid #000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                marginRight: '0.5rem',
                color: '#000',
                padding: '6px',
              }}
            >
              {isConclusionSelected('21c04ad7-3a8c-4a3d-b549-c03bf07f072d')
                ? ' x '
                : ''}
            </div>
            <span>
              Fator Pessoal de Insegurança
              {getFormattedOptions(questionIds.fatorPessoal)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
